// extracted by mini-css-extract-plugin
module.exports =  {"sidebar":"sidebar__-nAPI","hightlightIcon":"hightlightIcon__IgPgn"};